export default __webpack_public_path__ + "static/media/prana08.f3101aa3.JPG";